import {h, Fragment} from "preact"
import { defaultConfig, topSearches } from "../config"
import { HistoryElement } from "@nosto/preact"
import { useEffect, useRef } from "preact/hooks"

export default function History() {
    const closeSearchBtnRef = useRef(null);

    useEffect(() => {
        closeSearchBtnRef.current = document.querySelector('.search-modal__close-button');
    }, []);
    
    const handleSearchClick = (event) => {
        if(closeSearchBtnRef.current && event.target.closest('.keywords-item')) {
            closeSearchBtnRef.current.click();
        }
    }

    useEffect(() => {
        if(window.nostojs) {
            window.nostojs(api => {
               api
                .createRecommendationRequest({ includeTagging: true })
                .setElements(["searchdropdown-nosto-1"])
                .load({ skipPageViews: true, skipEvents: true })
            })
        }
    }, [])

    return (
        <div class="ns-autocomplete empty">
            <div class="ns-autocomplete-section keywords">
                <div class="ns-autocomplete-section-header">Top Searches</div>
                <div class="ns-autocomplete-keywords-container" onClick={handleSearchClick}>
                    {topSearches.map(item => (
                        <a class="keywords-item" href={item.url}>
                            {item.text}
                        </a>
                    ))}
                </div>
            </div>

            <div class="nosto_element ns-autocomplete-section products" id="searchdropdown-nosto-1"></div>
        </div>
    )
}
